import Tracked from '~/components/Tracked';
import type { MenuLinkProps } from '~/legacy/types';
import type { TrackedButtonClickName } from '~/services/gtm.client';

const MenuLink = ({ title, link }: MenuLinkProps) => {
  return (
    <Tracked.ExternalLink
      href={link}
      name={title as TrackedButtonClickName}
      variant="none"
      className="main-header__nav__menu-link-cta"
      pagePosition="Header"
    >
      {title}
    </Tracked.ExternalLink>
  );
};

export default MenuLink;
